module.exports = __webpack_public_path__ + "static/media/06.fc9963c1.png";